<div class="confirm-withdrawal-dialog">
  <img src="../../../assets/images/withdrawalDIalogue.png" alt="" style="display: block; margin: 0 auto;">
  <h2 mat-dialog-title class="text-center"><strong>{{title}}</strong></h2>
  <div mat-dialog-content>
    <p class="text-center">{{query}}</p>
  </div>
  <div mat-dialog-actions align="center" style="flex-direction: column;">
    <button class="btn add-btn" [mat-dialog-close]="true">Yes, I am Sure</button>
    <button mat-button [mat-dialog-close]="false" >Go Back</button>
  </div>
</div>
